var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"docking-stations-map"},[_c('h3',[_vm._v(_vm._s(_vm.$t('docking_stations_map.docking_stations_map')))]),_c('div',{staticClass:"statistics d-flex"}),_c('DockingStationsMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }